import type { Locale } from "@/i18n-config";
import { defineLocaleRecord } from "@/i18n-config";

export type RelatedCoursesCopy = {
  coursePageTitle: string;
  completionTitle: string;
  progressTitle: string;
  goToProgress: string;
  chooseNextCourse: string;
  previousCourses: string;
  nextCourses: string;
};

const relatedCoursesCopyByLocale = defineLocaleRecord<RelatedCoursesCopy>({
  en: {
    coursePageTitle: "Related courses",
    completionTitle: "Next courses",
    progressTitle: "Recommended next courses",
    goToProgress: "Go to your progress",
    chooseNextCourse: "Choose next course",
    previousCourses: "Previous courses",
    nextCourses: "Next courses",
  },
  de: {
    coursePageTitle: "Aehnliche Kurse",
    completionTitle: "Naechste Kurse",
    progressTitle: "Empfohlene naechste Kurse",
    goToProgress: "Zu deinem Fortschritt",
    chooseNextCourse: "Naechsten Kurs waehlen",
    previousCourses: "Vorherige Kurse",
    nextCourses: "Naechste Kurse",
  },
  fr: {
    coursePageTitle: "Parcours lies",
    completionTitle: "Parcours suivants",
    progressTitle: "Parcours suivants recommandes",
    goToProgress: "Voir votre progression",
    chooseNextCourse: "Choisir le prochain parcours",
    previousCourses: "Parcours precedents",
    nextCourses: "Parcours suivants",
  },
  es: {
    coursePageTitle: "Cursos relacionados",
    completionTitle: "Siguientes cursos",
    progressTitle: "Siguientes cursos recomendados",
    goToProgress: "Ir a tu progreso",
    chooseNextCourse: "Elegir siguiente curso",
    previousCourses: "Cursos anteriores",
    nextCourses: "Siguientes cursos",
  },
  it: {
    coursePageTitle: "Corsi correlati",
    completionTitle: "Prossimi corsi",
    progressTitle: "Prossimi corsi consigliati",
    goToProgress: "Vai ai tuoi progressi",
    chooseNextCourse: "Scegli il prossimo corso",
    previousCourses: "Corsi precedenti",
    nextCourses: "Prossimi corsi",
  },
  pt: {
    coursePageTitle: "Cursos relacionados",
    completionTitle: "Proximos cursos",
    progressTitle: "Proximos cursos recomendados",
    goToProgress: "Ir para o seu progresso",
    chooseNextCourse: "Escolher proximo curso",
    previousCourses: "Cursos anteriores",
    nextCourses: "Proximos cursos",
  },
  uk: {
    coursePageTitle: "Схожі курси",
    completionTitle: "Наступні курси",
    progressTitle: "Рекомендовані наступні курси",
    goToProgress: "Перейти до прогресу",
    chooseNextCourse: "Обрати наступний курс",
    previousCourses: "Попередні курси",
    nextCourses: "Наступні курси",
  },
  ru: {
    coursePageTitle: "Похожие курсы",
    completionTitle: "Следующие курсы",
    progressTitle: "Рекомендуемые следующие курсы",
    goToProgress: "Перейти к прогрессу",
    chooseNextCourse: "Выбрать следующий курс",
    previousCourses: "Предыдущие курсы",
    nextCourses: "Следующие курсы",
  },
});

export function getRelatedCoursesCopy(locale: Locale): RelatedCoursesCopy {
  return relatedCoursesCopyByLocale[locale];
}
